"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var crypto_1 = __importDefault(require("crypto"));
var UploadService_1 = require("./UploadService");
var UploadStore = (function () {
    function UploadStore(uploadService) {
        var _this = this;
        this.uploadService = uploadService;
        this.getUploadProgress = function (id) {
            return _this.uploadTrackers.find(function (tracker) { return tracker.id === id; });
        };
        this.getAllUploadsProgress = function () {
            return _this.uploadTrackers;
        };
        this.upload = function (file, _a) {
            var _b = _a === void 0 ? {} : _a, folderId = _b.folderId;
            _this.uploadService.validateFileUpload({ file: file, folderId: folderId });
            var id = crypto_1.default.randomBytes(16).toString("base64");
            _this.insertUploadProgress({
                id: id,
                state: UploadService_1.UploadState.Pending,
                percent: 0,
                file: file,
                folderId: folderId,
            });
            _this.uploadService.upload({ file: file, folderId: folderId }, _this.updateUploadProgress(id));
            return id;
        };
        this.waitForUpload = function (uploadId) {
            return new Promise(function (resolve) {
                (0, mobx_1.reaction)(function () {
                    var uploadProgress = _this.getUploadProgress(uploadId);
                    return uploadProgress && uploadProgress.url;
                }, function (url, reaction) {
                    if (url) {
                        reaction.dispose();
                        resolve(_this.getUploadProgress(uploadId));
                    }
                });
            });
        };
        this.retry = function (uploadId) {
            var updateUploadProgress = _this.updateUploadProgress(uploadId);
            updateUploadProgress({
                state: UploadService_1.UploadState.Pending,
                percent: 0,
            });
            var uploadProgress = _this.getUploadProgress(uploadId);
            var folderId = uploadProgress.folderId, file = uploadProgress.file;
            if (uploadProgress != undefined && file != undefined) {
                _this.uploadService.upload({ file: file, folderId: folderId }, updateUploadProgress);
            }
        };
        this.insertUploadProgress = function (uploadTracker) {
            _this.uploadTrackers = __spreadArray(__spreadArray([], __read(_this.uploadTrackers), false), [uploadTracker], false);
        };
        this.updateUploadProgress = function (id) {
            return function (toUpdate) {
                var state = toUpdate.state, percent = toUpdate.percent, url = toUpdate.url, dataUrl = toUpdate.dataUrl, uploadResponse = toUpdate.uploadResponse;
                _this.uploadTrackers = _this.uploadTrackers.map(function (tracker) {
                    if (tracker.id === id) {
                        if (state) {
                            tracker.state = state;
                        }
                        if (percent) {
                            tracker.percent = percent;
                        }
                        if (url) {
                            tracker.url = url;
                        }
                        if (dataUrl) {
                            tracker.dataUrl = dataUrl;
                        }
                        if (uploadResponse) {
                            tracker.uploadResponse = uploadResponse;
                        }
                    }
                    return tracker;
                });
            };
        };
        this.uploadTrackers = [];
    }
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], UploadStore.prototype, "uploadTrackers", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UploadStore.prototype, "upload", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UploadStore.prototype, "retry", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UploadStore.prototype, "insertUploadProgress", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UploadStore.prototype, "updateUploadProgress", void 0);
    return UploadStore;
}());
exports.default = UploadStore;
